module.exports = __webpack_public_path__ + "img/1556774964.d346eb3d.jpg";